import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// CLOSE-MASTER VERIFICATION (Bank / IT / Cost Center / DCA / Sub DCA / Client / Sub Client / TL Agency)
// Legacy: /Home/VerifyClose<Type> + the shared Close<Type> partial. Every type follows the same
// closing workflow (ClosingDetails + CloseLevelAccess), only the route names differ — the page's
// per-type config (CLOSE_TYPES in VerifyCloseMaster.jsx) supplies them.
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — masters whose closing request is pending at this role (spGetCloseDetailsbyRoleid @CloseType).
export const getCloseQueue = async (route, params) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/${route}`, { params, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Closing details for one master: close flags, this role's CloseLevelAccess / levels and the list of
// other transactions still pending against it.
export const getClosePendings = async (route, params) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/${route}`, { params, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject the closing (success literal "Notified").
export const saveCloseNotification = async (route, payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/${route}`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
